import { defineMessages, IntlShape } from "react-intl";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";

const messagesDesc = defineMessages<string>({
  amount: {
    id: "deals.cardFilterOption.amount.descDirection",
    defaultMessage: "Highest to lowest",
    description: "Deals card filter option - Amount desc direction",
  },
  closingDate: {
    id: "deals.cardFilterOption.expectedCloseDate.descDirection",
    defaultMessage: "Oldest last",
    description: "Deals card filter option - Expected Close Date desc direction",
  },
  createdAt: {
    id: "deals.cardFilterOption.createdAt.descDirection",
    defaultMessage: "Most recent",
    description: "Deals card filter option - Created at desc direction",
  },
  daysInStage: {
    id: "deals.cardFilterOption.daysInStage.descDirection",
    defaultMessage: "Most days in stage",
    description: "Deals card filter option - Days in stage desc direction",
  },
  updatedAt: {
    id: "deals.cardFilterOption.modifiedAt.descDirection",
    defaultMessage: "Most recent",
    description: "Deals card filter option - Modified at desc direction",
  },
});

const messagesAsc = defineMessages<string>({
  amount: {
    id: "deals.cardFilterOption.amount.ascDirection",
    defaultMessage: "Lowest to highest",
    description: "Deals card filter option - Amount asc direction",
  },
  closingDate: {
    id: "deals.cardFilterOption.expectedCloseDate.ascDirection",
    defaultMessage: "Oldest first",
    description: "Deals card filter option - Expected Close Date asc direction",
  },
  createdAt: {
    id: "deals.cardFilterOption.createdAt.ascDirection",
    defaultMessage: "Least recent",
    description: "Deals card filter option - Created at asc direction",
  },
  daysInStage: {
    id: "deals.cardFilterOption.daysInStage.ascDirection",
    defaultMessage: "Least days in stage",
    description: "Deals card filter option - Days in stage asc direction",
  },
  updatedAt: {
    id: "deals.cardFilterOption.modifiedAt.ascDirection",
    defaultMessage: "Least recent",
    description: "Deals card filter option - Modified at asc direction",
  },
});

const getSortDirectionNameForField = (
  intl: IntlShape,
  fieldName: string,
  order: SortOrder
): string =>
  order === SortOrder.DESC
    ? intl.formatMessage(messagesDesc[fieldName])
    : intl.formatMessage(messagesAsc[fieldName]);

export default getSortDirectionNameForField;
